<div class="switch-container" [ngClass]="{ 'compact': compact }">
  <div class="switch" [ngClass]="{ 'small': size === 'small' }">
    <button
      class="slider {{theme}}"
      (click)="onClick()"
      [ngClass]="isChecked ? 'slider-checked' : 'slider-unchecked'"
      [attr.data-test]="dataTest">
    </button>
  </div>
</div>